import store from 'app/store';

export default () => new Promise(() => {
  store.dispatch(null);
});
